import React, { FC } from 'react';
import styles from './ProvidedServices.module.scss';

export interface ProvidedServicesProps {
  type: string;
  sizeUnit: string;
  measurementUnit: string;
  capacity: string;
  capacityMeasurement: string;
  termLength: string | number;
  termLengthMeasurement: string;
  location: string;
}

const ProvidedServices: FC<ProvidedServicesProps> = ({
  type,
  sizeUnit,
  measurementUnit,
  capacity,
  capacityMeasurement,
  termLength,
  termLengthMeasurement,
  location,
}: ProvidedServicesProps) => {
  if (!type && !sizeUnit && !capacity && !termLength && !location) {
    return null;
  }

  return (
    <ul className={styles.container}>
      {!!type && (
        <li className={styles.item}>{type}</li>
      )}
      {!!sizeUnit && (
        <li className={styles.item}>{`${sizeUnit} ${measurementUnit}`}</li>
      )}
      {!!capacity && (
        <li className={styles.item}>{`${capacity} ${capacityMeasurement}`}</li>
      )}
      {!!termLength && (
        <li className={styles.item}>{`${termLength} ${termLengthMeasurement}`}</li>
      )}
      {!!location && (
        <li className={styles.item}>{location}</li>
      )}
    </ul>
  );
};

export default ProvidedServices;
